import React from 'react';
import cx from 'clsx';
import {
  Box,
  Divider,
  ExpansionPanel,
  ExpansionPanelProps,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';

export type Props = ExpansionPanelProps & {
  summary?: React.ReactNode;
  icon?: React.ReactNode;
};

export type SummaryProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
};

export const Summary = ({ title, subtitle }: SummaryProps) => (
  <Box>
    {title && <Typography variant="h3">{title}</Typography>}
    {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
  </Box>
);

const RosteringExpansionPanel = ({
  id,
  summary,
  children,
  icon,
  className,
  square,
  ...expansionPanelProps
}: Props) => {
  const classes = useStyles();

  return (
    <ExpansionPanel
      className={cx({ [classes.rounded]: !square }, className)}
      {...expansionPanelProps}
    >
      <ExpansionPanelSummary aria-controls={id} id={id} expandIcon={<ExpandMoreIcon />}>
        <Grid container alignItems="center" spacing={3}>
          {icon && (
            <Grid item xs="auto">
              <Box className={classes.iconContainer}>{icon}</Box>
            </Grid>
          )}
          <Grid item xs>
            {summary}
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item>{children}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

const useStyles = makeStyles(theme => ({
  rounded: {
    borderRadius: 4,
    overflow: 'hidden'
  },
  iconContainer: {
    display: 'flex',
    height: 96,
    width: 96,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4
  }
}));

export default RosteringExpansionPanel;
